<template>
  <div class="flex-column width-100 align-items-center justify-content-start bg-image min-height bg-lightgrey" id="body-div">
    <div class="flex-column width-100 align-items-center justify-content-start margin-t" style="padding: 0 3%">
      <div v-if="monthTaskInfoShow" class="flex-column align-items-center justify-content-center width-100 bg-jinli3">
        <div class="width-100 flex-row align-items-center justify-content-start margin-bss" style="position: relative; height: 2.7rem">
          <van-image :src="require('../assets/image/home/mrrw.png')" width="31%" height="1rem" fit="contain" class="margin-ts" />
        </div>
        <div class="width-100 bg-white br-reg flex-column align-items-center justify-content-around" style="z-index: 2; padding: 3%">
          <div class="flex-row width-100 align-items-center justify-content-around margin-ts">
            <div class="flex-column justify-content-center align-items-center width-33">
              <div class="fm-sh-regular fs-mid black canNotWrap">
                今日登录
                <!-- ({{ monthTaskInfo.day_task_like_num }}) -->
              </div>

              <div v-if="monthTaskInfo.is_login != 1" class="fm-sh-bold fs-super-big">
                <van-icon name="checked" color="#999999" size="28px" style="line-height: 1.75rem; height: 1.75rem" />
              </div>
              <div v-else class="margin-tss" style="line-height: 1.75rem; height: 1.75rem">
                <van-icon name="checked" color="#0C58EF" size="28px" style="line-height: 1.75rem; height: 1.75rem" />
              </div>
            </div>
            <div style="height: 3rem; width: 1px; background: #dbdbdb"></div>
            <div class="flex-column justify-content-center align-items-center width-33">
              <div class="fm-sh-regular fs-mid black">
                时长(分钟)
                <!-- ({{ monthTaskInfo.day_task_comment_num }}) -->
              </div>
              <!-- v-if="monthTaskInfo.day_task_comment_num > monthTaskInfo.day_comment_num" -->
              <div style="color: #2559f5" class="fm-sh-bold fs-super-big">
                {{ monthTaskInfo.app_use_time }}
              </div>
              <!-- <div v-else class="margin-tss" style="line-height: 1.75rem; height: 1.75rem">
                <van-icon name="checked" color="#0C58EF" size="28px" style="line-height: 1.75rem; height: 1.75rem" />
              </div> -->
            </div>
            <div style="height: 3rem; width: 1px; background: #dbdbdb"></div>
            <div class="flex-column justify-content-center align-items-center width-33">
              <div class="fm-sh-regular fs-mid black">
                日分享
                <!-- ({{ monthTaskInfo.day_task_forward_num }}) -->
              </div>
              <!--  v-if="monthTaskInfo.day_task_forward_num > monthTaskInfo.day_forward_num" style="color: #2559f5" -->
              <div class="fm-sh-bold fs-super-big">
                {{ monthTaskInfo.day_forward_num }}
              </div>
              <!-- <div v-else class="margin-tss" style="line-height: 1.75rem; height: 1.75rem">
                <van-icon name="checked" color="#0C58EF" size="28px" style="line-height: 1.75rem; height: 1.75rem" />
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="monthTaskInfoShow" class="flex-column align-items-center justify-content-center width-100 bg-jinli2">
        <div class="width-100 flex-row align-items-center justify-content-start margin-bss" style="position: relative; height: 2.7rem">
          <van-image :src="require('../assets/image/home/cbrw.png')" width="38%" height="1rem" fit="contain" class="margin-ts" />
          <van-image
            :src="require('../assets/image/home/cbrw-title.png')"
            height="5rem"
            fit="fill"
            width="5rem"
            style="position: absolute; top: -0.75rem; right: 3%; z-index: 1"
          />
        </div>
        <div class="width-100 bg-white br-reg flex-column align-items-center justify-content-around" style="z-index: 2; padding: 3%">
          <div class="flex-row width-100 align-items-center justify-content-around margin-ts">
            <div class="flex-column justify-content-center align-items-center width-25">
              <div class="fm-sh-regular fs-mid black">点赞</div>
              <div style="color: #2559f5" class="fm-sh-bold fs-super-big">{{ monthTaskInfo.like_num }}</div>
            </div>
            <div style="height: 3rem; width: 1px; background: #dbdbdb"></div>
            <div class="flex-column justify-content-center align-items-center width-25">
              <div class="fm-sh-regular fs-mid black">评论</div>
              <div style="color: #2559f5" class="fm-sh-bold fs-super-big">{{ monthTaskInfo.comment_num }}</div>
            </div>
            <div style="height: 3rem; width: 1px; background: #dbdbdb"></div>
            <div class="flex-column justify-content-center align-items-center width-25">
              <div class="fm-sh-regular fs-mid black">分享</div>
              <div style="color: #2559f5" class="fm-sh-bold fs-super-big">{{ monthTaskInfo.forward_num }}</div>
            </div>
            <div style="height: 3rem; width: 1px; background: #dbdbdb"></div>
            <div class="flex-column justify-content-center align-items-center width-25" @click="$router.push('/individualCompletion')">
              <van-image :src="require('../assets/image/home/ckmx.png')" width="1rem" height="1rem" fit="fill" />
              <div class="grey-999 fs-sml width-100 textAlign-c margin-tss" style="transform: scale(0.85)">查看明细</div>
            </div>
          </div>
          <div
            v-if="monthTaskInfo.jump_picture_url"
            class="width-100 overflow-h br-reg margin-ts"
            style="height: 4rem"
            @click="jumpUrlPic(monthTaskInfo.jump_url)"
          >
            <van-image
              width="100%"
              height="4rem"
              fit="fill"
              :src="monthTaskInfo.jump_picture_url ? monthTaskInfo.jump_picture_url : require('../assets/image/home/yueting.png')"
            />
          </div>
        </div>
      </div> -->
      <div class="width-100 bg-white br-reg" style="padding: 0 3% 3%; margin-top: 15px" v-if="wxList.length > 0">
        <div class="width-100 flex-row align-items-center justify-content-spaceBetween margin-ts" style="position: relative">
          <div class="width-33 flex-row align-items-center justify-content-center" style="height: 2rem">
            <van-image :src="require('../assets/image/home/wxgj.png')" height="2rem" fit="contain" />
          </div>
        </div>
        <div class="width-100 margin-bs" v-for="(item, key) in wxList" :key="key">
          <div class="width-100 flex-row align-items-center justify-content-spaceBetween" style="height: 4.4rem" @click="openWeChat(item.wechat_url)">
            <div v-if="item.manuscript_picture_url">
              <div style="width: 7rem; height: 4.4rem" class="margin-r">
                <van-image width="100%" height="4.4rem" :src="item.manuscript_picture_url" fit="cover" class="br-reg overflow-h" />
              </div>
            </div>
            <div class="width-100 height-100 flex-column align-items-star justify-content-spaceBetween">
              <div class="fs-mid fm-sh-regular show-line-2">{{ item.manuscript_title }}</div>
              <div class="width-100 flex-row align-items-center justify-content-spaceBetween">
                <div class="grey-999 fm-sh-regular fs-sml">{{ item.lose_efficacy_time }}</div>
                <div :style="{ color: item.state == 2 ? '#e3e3e3' : '#d83e1c' }" class="fs-sml">
                  {{ item.state == 2 ? '未阅读' : '已阅读' }}<van-icon name="checked" class="margin-ls"></van-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-column align-items-center justify-content-start width-100 bg-jinli2">
        <div class="width-100 flex-row align-items-center justify-content-spaceBetween margin-ts" style="position: relative">
          <div class="width-33 flex-row align-items-center justify-content-center" style="height: 2rem">
            <van-image :src="require('../assets/image/home/appxw.png')" height="2rem" fit="contain" @click="visibilty" />
          </div>
          <!-- <div class="fs-sml" style="line-height: 2rem; zoom: 0.83; color: #e1bb8a">
            每完成<span style="color: #f2522e">3</span>篇稿件转赞评获得一次抽奖机会
          </div> -->
        </div>
        <div class="width-100 bg-white br-reg flex-column align-items-center justify-content-center" style="z-index: 2; padding: 0 0 3%">
          <van-empty v-show="propagateTask.propagete_task_lists.length == 0" description="暂无任务" />
          <div
            v-show="propagateTask.propagete_task_lists.length != 0"
            v-for="(item, key) in propagateTask.propagete_task_lists"
            :key="key"
            class="width-100 margin-ts"
          >
            <div class="width-100 flex-row align-items-center justify-content-spaceBetween" style="height: 4.4rem" @click="clickPropagateTask(item)">
              <div>
                <div style="width: 7rem; height: 4.4rem" class="margin-r">
                  <van-image width="100%" height="4.4rem" :src="item.manuscript_picture_url" fit="cover" class="br-reg overflow-h" />
                </div>
              </div>
              <div class="width-100 height-100 flex-column align-items-star justify-content-spaceBetween">
                <div class="fs-mid fm-sh-regular show-line-2">{{ item.manuscript_title }}</div>
                <div class="grey-999 fm-sh-regular fs-sml">{{ item.lose_efficacy_time }}失效</div>
              </div>
            </div>
            <div class="flex-row align-items-center justify-content-around width-100 margin-ts">
              <div :class="['fs-mid fm-sh-regular', item.like_state == 1 ? 'reds' : 'greys']">点赞<van-icon name="checked" size="16" /></div>
              <div style="height: 1.5rem; width: 1px; background: #d1d1d1"></div>
              <div :class="['fs-mid fm-sh-regular', item.comment_state == 1 ? 'reds' : 'greys']">评论<van-icon name="checked" size="16" /></div>
              <div style="height: 1.5rem; width: 1px; background: #d1d1d1"></div>
              <div :class="['fs-mid fm-sh-regular', item.forward_state == 1 ? 'reds' : 'greys']">转发<van-icon name="checked" size="16" /></div>
            </div>
          </div>
        </div>
      </div>
      <div class="width-100 textAlign-c margin-ts fs-sml grey-999">{{ homeInfo.naming_name }}</div>
    </div>
    <div style="margin-bottom: 100px"></div>
    <van-overlay :show="show" style="z-index: 11">
      <div style="z-index: 15; position: relative" class="height-100 width-100 flex-column align-items-center justify-content-start">
        <div
          :style="{ height: (overlayWidth / 750) * 950 + 'px' }"
          v-if="type == 0 || type == 1"
          :class="['width-100 position-relative', type == 0 ? 'day1' : 'day2']"
        >
          <div
            :style="{ position: 'absolute', margin: '0 auto', top: '52%', zIndex: 16, right: 0, left: 0, height: '8rem' }"
            class="fs-mid fm-sh-regular width-50 textAlign-c flex-column align-items-center justify-content-center"
            @click="type == 0 ? (show = false) : $router.push('sweepstakesPage')"
          >
            <van-image
              :src="
                jp_infoList.jp_info.picture_url
                  ? jp_infoList.jp_info.picture_url
                  : jp_infoList.next_jp_info.picture_url
                  ? jp_infoList.next_jp_info.picture_url
                  : require('../assets/image/home/gift.png')
              "
              fit="contain"
              height="70%"
              width="90%"
            />
            <div class="flex-row align-items-center justify-content-center fs-sml grey-999 margin-tss">
              {{ type == 0 ? '还需' : '' }}
              <span v-if="type == 0" class="fs-sml red fw-mid"> {{ jp_infoList.next_jp_info.sign_num - numberDaysRegistered }} </span>
              <div v-if="type == 0" class="fs-sml grey-999">天即可获得奖品!</div>
              <div v-if="type == 1" class="flex-row align-items-center justify-content-center width-100">
                <div class="fs-sml grey-999">恭喜获得</div>
                <div class="fs-sml red">{{ jp_infoList.jp_info.prize_name }}</div>
                <div>×{{ jp_infoList.jp_info.prize_num }}</div>
              </div>
            </div>
          </div>
        </div>
        <van-image
          :src="require('../assets/image/home/finish-item.png')"
          fit="fill"
          :height="((overlayWidth * 0.8) / 638) * 733 + 'px'"
          width="80%"
          v-else-if="type == 2"
          style="position: absolute; top: 9rem; z-index: 13; margin: auto 0"
        />
        <div
          :style="{ position: 'absolute', margin: '0 auto', top: '26rem', zIndex: 14, color: type == 2 ? 'white' : '#d31112', zIndex: 14 }"
          class="fs-mid fm-sh-regular width-50 textAlign-c"
          @click="type == 0 || jp_infoList.jp_info.prize_type != 2 ? (show = false) : $router.push('sweepstakesPage')"
        >
          {{ type == 0 || jp_infoList.jp_info.prize_type != 2 ? '确定' : '立即抽奖' }}
        </div>
        <div
          @click="show = false"
          style="background: rgba(51, 51, 51, 0.5); width: 28px; height: 28px; position: absolute; top: 30rem; margin: auto 0; z-index: 15"
          class="br-rol flex-row align-items-center justify-content-center margin-ts"
        >
          <van-icon name="cross" size="20" color="#fff" />
        </div>
      </div>
    </van-overlay>
    <van-popup v-model="show2" round position="bottom">
      <van-cascader v-model="cascaderValue" title="请选择部门" :options="deptList" @close="show = false" @finish="onFinish" />
    </van-popup>
    <div
      v-if="showRule"
      class="flex-row align-items-center justify-content-center"
      :style="{ height: 'calc(100vh)', width: overlayWidth + 'px', background: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, zIndex: 9999, left: 0 }"
    >
      <div class="width-100 height-100 flex-column align-items-center justify-content-center">
        <div class="width-80 bg-white br-mid padding-90 position-relative">
          <div style="overflow-y: scroll; max-height: 20rem; min-height: 10rem" class="scroll-h"><div v-html="homeInfo.rule"></div></div>
        </div>
        <div
          @click="showRule = false"
          class="br-rol margin-t flex-row align-items-center justify-content-center bg-white"
          style="width: 30px; height: 30px; z-index: 999"
        >
          <van-icon name="cross" size="18px" />
        </div>
      </div>
    </div>
    <div
      v-if="showItemGift"
      class="flex-row align-items-center justify-content-center"
      :style="{ height: 'calc(100vh)', width: overlayWidth + 'px', background: 'rgba(0,0,0,0.5)', position: 'fixed', top: 0, zIndex: 9999, left: 0 }"
    >
      <div class="width-80 bg-white br-mid padding-90 position-relative">
        <div
          @click="showItemGift = false"
          class="position-absolute br-rol flex-row align-items-center justify-content-center bg-white"
          style="top: -8px; right: -8px; width: 18px; height: 18px"
        >
          <van-icon name="cross" />
        </div>
        <div style="overflow-y: scroll; max-height: 20rem" class="scroll-h"><div v-html="homeInfo.rule" style="height: 100rem"></div></div>
      </div>
    </div>
  </div>
</template>
<script>
import { shopLogin } from '@/api/shop';
import {
  sign,
  getMonthTaskInfo,
  getPropagateTask,
  getDeptLists,
  bindDept,
  clickPropagateTask,
  get_member_info,
  get_wechat_propagate_task
} from '@/api/home';
import { deepClone } from '@/utils/fileUtils';
import { Toast, Dialog } from 'vant';
export default {
  data() {
    return {
      raffle_num: 0,
      wxList: [],
      wxdhNum: 0,
      showRule: false,
      monthTaskInfoShow: true,
      cascaderValue: '',
      show2: false,
      height: '',
      height2: '',
      show: false,
      overlayWidth: 0,
      overlayHeight: 0,
      type: 0,
      homeInfo: { sign_cycle_lists: [], sign_record_info: { continuous_sign_num: '' } },
      userInfo: { id: null, name: '', nickname: '', avatar_url: '', dept_id: null, dept_name: '', token: '' },
      numberDaysRegistered: 0,
      activity_info: null,
      external_activities_lists: [],
      external_goods_lists: [],
      monthTaskInfo: { like_num: '0', comment_num: '0', forward_num: '0', jump_url: '', jump_picture_url: '' },
      propagateTask: {
        member_data_info: {
          id: '',
          member_id: '',
          residue_propagate_num: '',
          propagate_num: '',
          raffle_num: '',
          ticket_num: '',
          propaganda_exchange_ratio: ''
        },
        new_add_ticker_num: 0,
        propagete_task_lists: []
      },
      finish: false,
      signInDays: '',
      chance: 0,
      deptList: [],
      jp_infoList: { jp_info: { picture_url: '' }, next_jp_info: { picture_url: '', sign_num: '' } },
      showgiftitem: {},
      showItemGift: false
    };
  },
  watch: {
    'propagateTask.propagete_task_lists': {
      handler() {
        this.$nextTick(() => {
          if (document.getElementById('chuan-bo')) {
            this.height2 = ((document.getElementById('chuan-bo').clientWidth * 0.7 * 120) / 450).toFixed(0) + 'px';
          }
        });
      }
    },
    'location.href': {
      deep: true,
      immediate: true,
      handler() {
        localStorage.setItem('isShop', false);
      }
    }
  },
  beforeMount() {
    let _this = this;
    // window.addEventListener('visibilitychange', _this.visibilty);
    document.addEventListener('visibilitychange', _this.visibilty);
    getDeptLists()
      .then((res) => {
        if (res.code == 0) {
          this.deptList = res.data.map((item) => {
            item.text = item.type_name;
            item.value = item.type;
            if (item.lists) {
              item.children = item.lists.map((its) => {
                its.text = its.name;
                its.value = its.id;
                return its;
              });
            }
            return item;
          });
        }
      })
      .catch((err) => console.log(err));
    this.$nextTick(() => {
      if (document.getElementById('body-div')) {
        this.overlayWidth = document.getElementById('body-div').clientWidth;
        this.overlayHeight = document.documentElement.clientHeight;
      }
      if (document.getElementById('ji-fen-shop')) {
        this.height = ((document.getElementById('ji-fen-shop').clientWidth * 0.3 * 0.9 * 6) / 7).toFixed(0) + 'px';
      }
      get_wechat_propagate_task().then((res) => {
        if (res.code == 0) {
          this.$data.wxdhNum = res.data.propaganda_exchange_ratio;
          this.$data.wxList = res.data.propagete_task_lists;
        }
      });
    });
    this.userInfo = this.$store.state.userInfo;
    this.getMonthTaskInfo();
    getPropagateTask()
      .then((res) => {
        console.log('beforeMount');
        if (res.code == 0) {
          this.propagateTask = res.data;
          if (res.data.new_add_ticker_num != 0) {
            this.show = true;
            this.type = 2;
          }
          this.raffle_num += res.data.member_data_info.raffle_num * 1;
        }
      })
      .catch((err) => {
        console.log(err);
      });
    get_member_info()
      .then((res) => {
        if (res.code == 0) {
          this.userInfo = res.data;
        }
      })
      .catch((err) => console.log(err));
  },
  methods: {
    signIn() {
      sign().then((re) => {
        if (re.code == 0) {
          this.numberDaysRegistered += 1;
          if (re.data.jp_info.picture_url) {
            this.type = 1;
            this.show = true;
          } else {
            this.type = 0;
            this.show = true;
          }
          this.jp_infoList = re.data;
        }
        {
          Dialog.alert({
            message: re.msg
          }).then(() => {
            // on close
          });
        }
      });
    },
    routerPush() {
      this.$router.push({ path: '/departmentCompletion', query: { month: this.$dayjs().format('YYYY-MM-DD'), name: this.userInfo.dept_name } });
    },
    visibilty() {
      console.log(document.visibilityState);
      if (document.visibilityState == 'visible') {
        getPropagateTask()
          .then((res) => {
            if (res.code == 0) {
              this.propagateTask = res.data;
              if (res.data.new_add_ticker_num != 0) {
                this.show = true;
                this.type = 2;
              }
              let num = res.data.member_data_info.raffle_num * 1 + res.data.new_add_ticker_num * 1;
              get_wechat_propagate_task().then((re) => {
                if (re.code == 0) {
                  this.$data.wxdhNum = re.data.propaganda_exchange_ratio;
                  this.$data.wxList = re.data.propagete_task_lists;
                  this.raffle_num = num + re.data.add_dh_num * 1;
                }
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    getMonthTaskInfo() {
      getMonthTaskInfo()
        .then((res) => {
          if (res.code == 0) {
            this.monthTaskInfo = res.data;
            this.monthTaskInfoShow = true;
          } else {
            this.monthTaskInfoShow = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openWeChat(wechat_url) {
      // location.href = wechat_url;
      window.open(wechat_url);
    },
    clickPropagateTask(item) {
      clickPropagateTask({ id: item.id })
        .then((res) => {
          if (res.code == 0) {
            //
            // window.open(item.manuscript_url);
            location.href = item.manuscript_url;
          }
        })
        .catch((err) => console.log(err));
    },
    onFinish(item) {
      this.show2 = false;
      bindDept({ dept_id: item.value }).then((res) => {
        if (res.code == 0) {
          this.userInfo.dept_name = item.selectedOptions[1].text;
          this.userInfo.dept_id = item.value;
          Toast.success('绑定成功');
          this.getMonthTaskInfo();
        }
      });
    },
    gotoRightNow(item) {
      location.href = item.url;
    },
    // 点击图片跳转
    jumpUrlPic(url) {
      location.href = url;
    },
    locationChange(item) {
      location.href = item.url;
    },
    openNewWindow(url) {
      window.open(url);
    },
    showGiftItem(item) {
      this.showgiftitem = item;
      console.log(item, 'giftItem'); //
      this.showItemGift = true;
    },
    goToShop() {
      if (this.userInfo.shop_id > 0) {
        shopLogin(this.$store.state.queryParams)
          // shopLogin({ account_id: '64b8b1fea95d5a0d21ffa25a', session_id: '6556c266f34e164c17f53a9f' })
          .then((res) => {
            let toast = Toast.loading({
              duration: 0,
              message: '登录中...',
              forbidClick: true,
              loadingType: 'spinner'
            });
            toast.clear();
            if (res.code == 0) {
              localStorage.setItem('jryjShop_token', res.data.token);
              this.$store.commit('setShopUserInfo', res.data);
              localStorage.setItem('isShop', 'true');
              this.$router.push({ path: '/shop_home', query: { canBack: true } });
            } else {
              Toast.fail('登录失败,您不是商家！');
            }
          })
          .catch((err) => {
            Toast(err.msg);
          });
      }
    }
  }
};
</script>
<style scoped>
.bg-image {
  background-image: url('../assets/image/home/banner1.png');
  background-size: 100%;
  background-repeat: no-repeat;
}
.bg-jinli {
  background-image: url('../assets/image/home/banner.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 0.35rem;
  margin-top: 20px;
  padding: 0 3% 3%;
  box-shadow: 0px 1px 4px 1px rgba(104, 104, 104, 0.3);
}
.bg-jinli2 {
  background-color: white;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 0.35rem;
  margin-top: 20px;
  padding: 0 3% 3%;
  box-shadow: 0px 1px 4px 1px rgba(104, 104, 104, 0.3);
}
.bg-jinli3 {
  background-image: url('../assets/image/home/banner.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 0.35rem;
  margin-top: 20px;
  padding: 0 3% 3%;
  box-shadow: 0px 1px 4px 1px rgba(104, 104, 104, 0.3);
}
.go-right-now {
  border: 1px solid #2456f4;
  color: #2456f4;
  padding: 3px 10px;
  height: 70%;
  line-height: 100%;
  font-size: 12px;
  transform: scale(0.8);
}
.go-right-now2 {
  border-radius: 50%;
  width: 14px;
  height: 14px;
  background: #cecece;
  line-height: 14px;
  text-align: center;
}
.greys {
  color: #ddd;
}
.blues {
  color: #2969fa;
}
::v-deep .van-overlay {
  z-index: 11;
}
::v-deep .van-overlay {
  z-index: 1000;
}
.day1 {
  background-image: url('../assets/image/home/two-day.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.day2 {
  background-image: url('../assets/image/home/get-gift.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>
